import * as React from "react"
import { isMobile, isTablet } from "@digits-shared/helpers/devicesHelper"

export enum SizeClass {
  Mobile = "mobile",
  Desktop = "desktop",
  Tablet = "tablet",
}

export type ResponsiveComponents<P = object> = {
  [SizeClass.Desktop]: React.ComponentType<P>
  [SizeClass.Mobile]: React.ComponentType<P>
  [SizeClass.Tablet]?: React.ComponentType<P>
}

/**
 * Accepts React.FCs (incl. styled-components) for keys matching each size class defined in the SizeClass enum. Both Components must contain the same props interface.
 *
 *  <ContextProvider>
 *    <ResponsiveComponent desktop={Home} mobile={MobileHome} />
 *  <ContextProvider/>
 *
 *  <Route
 *    path="/foo"
 *    render={() => (
 *       <ResponsiveComponent desktop={Home} mobile={MobileHome} />
 *    )}
 *  />
 */
export const ResponsiveComponent: React.FC<ResponsiveComponents> = ({
  mobile,
  desktop,
  tablet,
}) => {
  if (isTablet && tablet) {
    const Component = tablet
    return <Component />
  }

  if (isMobile) {
    const Component = mobile
    return <Component />
  }

  const Component = desktop
  return <Component />
}
